/**
 * Provides the federation endpoint context for the the apollo client.
 * @param context
 * @returns
 */
export const clientContext = (
  context: { [key: string]: unknown } = {},
): { [key: string]: unknown } => ({
  ...context,
  clientName: "federation",
});

/**
 * Takes global ID and returns a DB ID
 * @param globalId
 */
export const toDbId = (globalId: string): number => {
  return parseInt(atob(globalId).split(":")[1], 10);
};

/**
 * Takes an object type and database ID and returns a global ID
 *
 * @param objectType
 * @param dbId
 */
export function toGlobalId(objectType: string, dbId: number | string): string {
  return btoa([encodeURIComponent(objectType), dbId].join(":"));
}

/**
 * Decodes a global ID back to its object type and database ID
 *
 * @param globalId - Base64 encoded global ID
 * @returns Object with objectType and dbId, or null if invalid
 */
export function fromGlobalId(globalId: string): { objectType: string; dbId: number } | null {
  try {
    const decoded = atob(globalId);
    const [objectType, idStr] = decoded.split(":");
    const dbId = parseInt(idStr, 10);
    if (!objectType || isNaN(dbId)) {
      return null;
    }
    return { objectType: decodeURIComponent(objectType), dbId };
  } catch {
    return null;
  }
}
